// BTOCSITE-22701 add :: 선택옵션 선택 팝업, 서비스 가능 모델 선택 팝업
(function (global) {
    var IS_MYPAGE = false;  // 마이페이지 구분값

    var STORAGE_KEY = 'SUBSCRIBE_CART';

    var SAVE_OPTION_DATA = {
        serviceTypeList : null,
        serviceManagementList : null,
        serviceCycleList : null,
        serviceTypeListIndex : 0,
        serviceManagementListIndex : 0,
        serviceCycleListIndex : 0,
        serviceItemList : []
    };

    var tempData = {
        serviceTypeList : null,
        serviceManagementList : null,
        serviceCycleList : null,
        serviceTypeListIndex : 0,
        serviceManagementListIndex : 0,
        serviceCycleListIndex : 0,
        serviceItemList : []
    };

    var MODEL_DATA = {
        modelId : '',
        userFriendlyName : ''
    };

    // STEP1 :: 서비스 셀렉트
    var serviceSelectStep = {
        init : function(){
            var self = this;
            self.setting();
            self.bindEvent();
        },
        setting : function(){
            var self = this;
            self.$optionPopup = $('#pop_subs_common');
            self.$containBox = self.$optionPopup.find('article.st-service');
            self.$el = self.$containBox.parent();
            self.serviceTypeBox = self.$containBox.find('.select-info.select-box').eq(0);

            self.serviceTypeListUrl = self.$optionPopup.data('serviceTypeUrl');
            self.serviceManageUrl = self.$optionPopup.data('serviceManageUrl');
            self.serviceCycleUrl = self.$optionPopup.data('serviceCycleUrl');

            self.serviceTypeSelect = self.$containBox.find('select').eq(0);
            self.serviceManageSelect = self.$containBox.find('select').eq(1);
            self.serviceCycleSelect = self.$containBox.find('select').eq(2);

            self.hasServiceType = true;

            MODEL_DATA = {
                modelId : lgePdpSendData.modelId,
                userFriendlyName : ''
            };
            //self.setServiceType();

        },
        bindEvent : function(){
            var self = this;

            self.$containBox.on('announceValidate', function(){
                self.announceValidate();
            });

            self.$containBox.on('reset', function(){
                self.reset();
            });

            self.serviceTypeSelect.on('change', function(e){
                e.preventDefault();
                var $this = $(this);

                self.serviceManageSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');
                self.serviceCycleSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update');

                
                if (self.hasServiceType && !$(this).val() ) return;    // 서비스타입이 있고 값이 없을때

                lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceManageUrl,
                    {
                        "modelId": MODEL_DATA.modelId,
                        "svcTypeCd" : self.serviceTypeSelect.val()
                    },
                    function(result){                                                 
                        self.serviceManageSelect.empty();
                        self.serviceManageSelect.append('<option value="" class="placeholder">선택하세요</option>');
                        
                        result.data.serviceManagementList.forEach(function(item, idx){
                            var option;
                            option = '<option value="'+ item.managementType +'">'+ item.managementName +'</option>';                            
                            self.serviceManageSelect.append(option);
                        });
                        self.serviceManageSelect.prop('disabled', false);
                        self.serviceManageSelect.vcSelectbox('update');

                        tempData.serviceManagementList = result.data.serviceManagementList;
                        tempData.serviceTypeListIndex = $this.prop('selectedIndex');
                }); 
                
            });

            self.serviceManageSelect.on('change', function(e){
                e.preventDefault();
                var $this = $(this);

                self.serviceCycleSelect.prop('selectedIndex', 0).prop('disabled', true).vcSelectbox('update').trigger('change');

                if (!!$(this).val()){
                    lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceCycleUrl,
                        {
                            "modelId": MODEL_DATA.modelId,
                            "svcTypeCd" : self.serviceTypeSelect.val(),
                            "managementType" : self.serviceManageSelect.val()
                        },
                        function(result){                                                    
                            self.serviceCycleSelect.empty();
                            self.serviceCycleSelect.append('<option value="" class="placeholder">선택하세요</option>');
                            result.data.serviceCycleList.forEach(function(item, idx){
                                var option;
                                option = '<option value="'+ item.visitPer +'">'+ '1회/'+ item.visitPer +'개월'  +'</option>';                            
                                self.serviceCycleSelect.append(option);
                            });
                            self.serviceCycleSelect.prop('disabled', false);
                            self.serviceCycleSelect.vcSelectbox('update');

                            tempData.serviceCycleList = result.data.serviceCycleList;
                            tempData.serviceManagementListIndex = $this.prop('selectedIndex');
                    });
                }
            });

            self.serviceCycleSelect.on('change', function(e){
                e.preventDefault();
                var $this = $(this);

                tempData.serviceCycleListIndex = $this.prop('selectedIndex');

                tempData.serviceItemList = [];  // 구성 상품 목록 초기화
                // 서비스 선택이 완료되었을때 subscribeOptionSelectPop 에 알려줌
                var result = !!$this.val();
                self.selectComplete( result );
            });
        },

        setServiceType: function(){
            var self = this;

            self.serviceTypeSelect.prop('disabled', true);
            self.serviceTypeSelect.vcSelectbox('update');

            // 서비스 타입 불러오기
            lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceTypeListUrl, { "modelId": MODEL_DATA.modelId }, function(result){

                self.serviceTypeSelect.empty();

                if (result.data.serviceTypeYn == "Y"){

                    self.serviceTypeBox.show();
                    self.hasServiceType = true;

                    self.serviceTypeSelect.append('<option value="" class="placeholder">선택하세요</option>');
                    
                    result.data.serviceTypeList.forEach(function(item, idx){
                        var option;
                        if (item.svcTypeUseYn ==='Y'){
                            option = '<option value="'+ item.svcTypeCd +'">'+ item.svcTypeDesc +'</option>';
                            self.serviceTypeSelect.append(option);
                        }                        
                    });

                } else {
                    // 서비스 타입이 없을때
                    self.serviceTypeBox.hide();
                    self.hasServiceType = false;

                    var option = '<option value="" class="placeholder">선택하세요</option>';
                    self.serviceTypeSelect.append(option);

                    self.serviceTypeSelect.trigger('change');

                }

                self.serviceTypeSelect.prop('disabled', false);
                self.serviceTypeSelect.vcSelectbox('update');

                tempData.serviceTypeList = result.data.serviceTypeList;

            });
        },
        // 서비스 선택이 끝났음을 알려준다.
        selectComplete : function( result ){
            var self = this;
            self.$optionPopup.trigger('SERVICE_SELECT_COMPLETE', result);
        },

        getData: function(){
            var self = this;
            return {
                "modelId": MODEL_DATA.modelId,
                "svcTypeCd" : self.serviceTypeSelect.val(),
                "managementType" : self.serviceManageSelect.val(),
                "visitPer" : self.serviceCycleSelect.val()
            };
        },

        getSummaryData: function(){
            var self = this;
            return {
                'serviceGrade' : self.serviceTypeSelect.prop('selectedIndex') == 0 ? '' : self.serviceTypeSelect.find('option:selected').text(),
                'serviceType' : self.serviceManageSelect.prop('selectedIndex') == 0 ? '' : self.serviceManageSelect.find('option:selected').text(),
                'serviceCycle' : self.serviceCycleSelect.prop('selectedIndex') == 0 ? '' : self.serviceCycleSelect.find('option:selected').text()
            };
        },

        announceValidate : function(){
            var self = this;
            var result = !!self.serviceCycleSelect.val();
            self.$optionPopup.trigger('SERVICE_SELECT_COMPLETE', result);
        },

        reset : function(){
            var self = this;
            if (self.hasServiceType){
                self.serviceTypeSelect.prop('selectedIndex', 0).vcSelectbox('update').trigger('change');
            } else {
                self.serviceManageSelect.prop('selectedIndex', 0).vcSelectbox('update').trigger('change');
            }
            self.announceValidate();
        }
    }

    // STEP2 :: 서비스 가능 모델 선택
    var modelSelectStep = {
        init: function () {
            var self = this;
            self.setting();
            self.bindEvents();
            self.setObserver();
           
        },
        setting: function () {
            var self = this;
            self.isSaved = false;
            
            self.$optionPopup = $('#pop_subs_common');
            self.$containBox = self.$optionPopup.find('article.st-model');
            self.$el = self.$containBox.parent();
            self.$myProductinputLayerAutoComplete = self.$containBox.find(".input-layer");
            self.$myRegistCheckBtn = self.$containBox.find('.input-wrap .btn-check');
            self.$codeTab1 = self.$containBox.find(".form-wrap.category-select"); // 제품별 부착 위치 - 모델명/제조번호/바코드
            self.$saveBtn = self.$containBox.find('.btn-subscribe-submit');
            self.$modelNameChk = self.$containBox.find('#chk-model');
            self.$modelNameChkWrap = self.$containBox.find('.chk-wrap');
            
            self.$modelInput = self.$containBox.find("input[name='sku']");
            self.$modelCheckOk = self.$containBox.find(".type-ico").siblings("p.comp");
            self.$modelNotMatch = self.$containBox.find(".type-ico").siblings("p.err-msg.not-match");
            self.$modelEmpty = self.$containBox.find(".type-ico").siblings("p.err-msg.empty");

            self.barcodeModel = null;

            self.$serviceModelPopup = $('#popup_new2');
            self.$mpRegiPop = $('.popup-wrap.mp-regi');
            self.$modelModifyBox = $('.scrb-select-box').find('.scrb-select-model').hide();      // 서비스 가능 모델 변경영역

            self.checkedModelData = null;
            self.checkModelSuccess = false;

            self.barcodeModelLoad();

        },

        bindEvents: function () {
            var self = this;

            self.$containBox.on('announceValidate', function(){
                self.announceValidate();
            });

            self.$containBox.on('reset', function(){
                self.reset();
            });

            // BTOCSITE-22701 20230105:S 모델명 모름 클릭시
            self.$modelNameChk.on('click', function(){
                var chkKnown = $(this).prop('checked');
                var chkUsed = self.$modelNameChk.parents(".chk-wrap").siblings(".btn-check");
                if(chkKnown){
                    chkUsed.attr('disabled', true);
                    self.$modelInput.val('').attr('disabled', true);
                    self.requestSku(true);
                } else {
                    chkUsed.attr('disabled', false);
                    self.$modelInput.attr('disabled', false).trigger('input');
                    self.$saveBtn.attr('disabled', true);
                }
            });
            // BTOCSITE-22701 20230105:E 모델명 모름 클릭시

            // 모델명 변경 버튼 클릭시
            /*
            self.$serviceModelPopup.on('modify', function(){
                if (self.isSaved){
                    self.$modelInput.val('');
                    self.$modelCheckOk.removeClass('on');
                    if (self.$modelNameChk.prop('checked')){
                        self.$modelNameChk.trigger('click');
                    }
                    self.$serviceModelPopup.vcModal('show');
                }
            });
            */

            //모델명 입력 체크
            self.$modelInput.on("input", function (e) {
                self.checkModelSuccess = false;
                self.$modelCheckOk.removeClass("on");                

                if (e.target.value.length > 20) {
                    e.target.value = e.target.value.slice(0, 20);
                }

                clearTimeout(self.searchTimer);

                var searchVal = e.target.value;                
                if (searchVal.length < 5) {
                    self.$myProductinputLayerAutoComplete.parents(".input-wrap").removeClass("on");
                } else {
                    self.searchTimer = setTimeout(function () {
                        self.requestSearchAutoComplete(searchVal);
                    }, 300);
                }
            });

            self.$modelInput.on("focusout", function (e) {
                e.preventDefault();
                setTimeout(function () {
                    self.$myProductinputLayerAutoComplete.parents(".input-wrap").removeClass("on");
                }, 300);
            });

            //보유제품 등록하기 팝업 : 모델명 자동완성 클릭
            self.$myProductinputLayerAutoComplete.on("click", "a", function (e) {
                e.preventDefault();
                self.checkModelSuccess = false;                

                var modelName = $(this).attr("href").replace("#", "");
                var rtModelSeq = $(this).attr("data-rtModelSeq");
                if (modelName && modelName.length > 0) {
                    self.$modelInput.val(modelName.toUpperCase());
                    self.$myRegistCheckBtn.trigger("click");
                }
            });

            //보유제품 등록하기 팝업 : 제품 모델 확인 버튼
            self.$myRegistCheckBtn.on("click", function (e) {
                self.$modelInput.val(self.$modelInput.val().toUpperCase());
                self.checkModelSuccess = false;                

                if (self.$modelInput.val().length > 0) {
                    self.requestSku();
                } else {
                    self.$modelInput.focus();
                    self.$modelCheckOk.removeClass("on");
                    self.$modelNotMatch.removeClass("on");                           
                    self.$modelEmpty.addClass("on");
                }
                return false;
            });

            // 이미지 확대 클릭 방지
            $('a.btn-img-view').on('click',function(e){
                e.preventDefault();
            });           

            // 제품별 부착 위치 - 모델명/제조번호/바코드 이벤트
            self.$codeTab1.on('change', '.ui_selectbox:eq(0)', function(e){
                var index = this.selectedIndex;
                var selectbox = self.$codeTab1.find('.ui_selectbox:eq(1)');
                if(index == 0) {
                    selectbox.prop('disabled', true);
                } else {
                    selectbox.prop('disabled', false);
                    index--;
                    var barcodeModel = self.barcodeModel[index];
                    var optionTemplate = '<option value="{{modelName}}" data-image-url="{{imageUrl}}" data-image-alt="{{imageAlt}}" data-text="{{text}}">{{modelName}}</option>';

                    selectbox.find('option:not(:eq(0))').remove();
                    var arr = barcodeModel.modelList instanceof Array ? barcodeModel.modelList : [];
                    arr.forEach(function(item, index) {
                        if(!item.imageUrl || !item.imageUrl.length) {
                            item.text = item.imageAlt = "제품 이미지 준비중입니다.";
                            item.imageUrl = "/lg5-common/images/img-nodata.svg";
                        }
                        selectbox.append(vcui.template(optionTemplate, item));
                    });                        
                    selectbox.vcSelectbox('update');
                }
                selectbox.vcSelectbox('selectedIndex', 0, true);
            });

            self.$codeTab1.on('change', '.ui_selectbox:eq(1)', function(e){
                var index = this.selectedIndex;
                var selectbox = self.$codeTab1.find('.ui_selectbox:eq(1)');
                var option = selectbox.find('option').eq(index);

                var imageUrl = option.attr('data-image-url');
                var desc = option.attr('data-text');

                if(desc) {
                    self.$containBox.find('div.example-result p.bullet-text').html(vcui.string.replaceAll(option.attr('data-text'),"\n","<br>"));
                }
                if(imageUrl) {
                    self.$containBox.find('div.example-result img').attr({'src':option.attr('data-image-url'),'alt':option.attr('data-image-alt')}).css('opacity',1);
                }
            });


        },

        reset : function(){
            var self = this;

            self.checkedModelData = null;
            self.checkModelSuccess = false;
            self.$modelInput.val('');
            self.$modelCheckOk.removeClass('on');
            self.$modelNotMatch.removeClass('on');
            self.$modelEmpty.removeClass('on');
            if (self.$modelNameChk.prop('checked')){
                self.$modelNameChk.trigger('click');
            }
        },

        setObserver : function(){
            // 모델확인이 됬을때만 버튼 활성화
            var self = this;                        
            var validModelObserver = new MutationObserver(function(Mutations) {
                Mutations.forEach(function(Mutation) {
                    var isValidModel = $(Mutation.target).hasClass('on');

                    self.$optionPopup.trigger('SERVICE_MODEL_COMPLETE', isValidModel);
                });
            });
            validModelObserver.observe( self.$modelCheckOk.get(0), {attributes: true, attributeFilter : ['class']} );
        },

        getSummaryData : function(){
            var self = this;
            if (self.checkModelSuccess){
                return self.checkedModelData.salesCodeSuffix;
            } else {
                return '';
            }

        },

        announceValidate : function(){
            var self = this;
            var isValidModel = self.$modelCheckOk.hasClass('on');

            self.$optionPopup.trigger('SERVICE_MODEL_COMPLETE', isValidModel);

        },

        //검색어 입력중 검색
        requestSearchAutoComplete: function (value) {
            var self = this;
            var ajaxUrl = self.$optionPopup.data("autocompleteUrl");
            var sku = value.toUpperCase();
            var serviceSelectData = serviceSelectStep.getData();


            lgkorUI.requestAjaxData(ajaxUrl, 
                {
                    sku : sku,
                    modelId : serviceSelectData.modelId,
                    svcTypeCd : serviceSelectData.svcTypeCd,
                    managementType : serviceSelectData.managementType,
                    visitPer : serviceSelectData.visitPer
                },
                function (result) {
                    var data = result.data;

                    var arr = data && data.servicePossibleModelList instanceof Array ? data.servicePossibleModelList : [];
                    var $list_ul = self.$myProductinputLayerAutoComplete.find("ul");
                    $list_ul.empty();
                    if (arr.length > 0) {
                        var autoCompleteItemTemplate = '<li><a href="#{{input}}">{{#raw text}}</a></li>';
                        var replaceText = '<span class="search-word">' + sku + "</span>";
                        arr.forEach(function (item, index) {
                            $list_ul.append(
                                vcui.template(autoCompleteItemTemplate, {                                    
                                    input: item.salesCodeSuffix,
                                    text: vcui.string.replaceAll(item.salesCodeSuffix, sku, replaceText),
                                })
                            );
                        });

                        self.$myProductinputLayerAutoComplete
                            .find(".no-data")
                            .removeClass("on")
                            .end()
                            .find("ul")
                            .addClass("on")
                            .parents(".input-wrap")
                            .addClass("on");
                    } else {
                        self.$myProductinputLayerAutoComplete
                            .find("ul")
                            .removeClass("on")
                            .end()
                            .find(".no-data")
                            .addClass("on")
                            .parents(".input-wrap")
                            .addClass("on");
                    }
                }
            );
        },

        requestSku: function (isUnknown) {            
            var self = this;
            var ajaxUrl = self.$optionPopup.data("skuUrl");
            var sku = self.$modelInput.val();
            var isUnknownModel = isUnknown ? 'Y' : 'N';
            var serviceSelectData = serviceSelectStep.getData();

            if (ajaxUrl) {
                lgkorUI.requestAjaxData(
                    ajaxUrl,
                    {
                        sku : sku,
                        modelId : serviceSelectData.modelId,
                        svcTypeCd : serviceSelectData.svcTypeCd,
                        managementType : serviceSelectData.managementType,
                        visitPer : serviceSelectData.visitPer,
                        unknownModel : isUnknownModel
                    },
                    function (result) {
                        var data = result.data;
                        self.checkModelSuccess = false;

                        if (!!data.servicePossibleModelList.length){
                            // 모델명 모름 체크시 확인후 첫번째 모델 선택
                            if (isUnknown){
                                self.checkedModelData = data.servicePossibleModelList.find(function( item ){
                                    return item.virtualModelYn == 'Y';
                                });
                                self.checkModelSuccess = true;
                            } else {
                                self.checkedModelData = data.servicePossibleModelList.find(function( item ){
                                    return item.salesCodeSuffix == sku;
                                });                                
                                self.checkModelSuccess = true;
                            }
                            
                            MODEL_DATA.userFriendlyName = self.checkedModelData.rtModelDisplayNm;
                            MODEL_DATA.itemOptionType = self.checkedModelData.itemOptionType;
                        }

                        if (self.checkModelSuccess) {
                            self.$modelCheckOk.addClass("on");
                            self.$modelNotMatch.removeClass("on");
                            self.$modelEmpty.removeClass("on");

                            //console.log(data.childModelCode);
                            
                        } else {
                            self.$modelCheckOk.removeClass("on");
                            self.$modelNotMatch.addClass("on");                           
                            self.$modelEmpty.removeClass("on");                            

                            //self.emailConfirm(self.$modelInput);
                        }
                    },
                    "GET",
                    "json",
                    true
                );
            }
        },
        // 제품별 부착 위치 - 모델명/제조번호/바코드 모델 로드
        barcodeModelLoad: function(){
            var self = this;

            if(!self.barcodeModel) {               
                var selectBox = self.$optionPopup.find('.form-wrap.category-select .ui_selectbox:eq(0)');
                var ajaxUrl = self.$optionPopup.data('barcodeModelUrl');

                lgkorUI.requestAjaxData(ajaxUrl, null, function(result) {
                    var optionTemplate = '<option value="{{value}}">{{value}}</option>';
                    var data = result.data;
                    self.barcodeModel = data;

                    selectBox.find('option:not(:eq(0))').remove();
                    var arr = data instanceof Array ? data : [];
                    arr.forEach(function(item, index) {
                        item.value = item.categoryName
                        selectBox.append(vcui.template(optionTemplate, {"value":item.categoryName}));
                    });
                    selectBox.vcSelectbox('update');
                });
            }
        }

        
    };

    // STEP3 :: 구성상품 선택
    var itemSelectStep = {
        init : function(){
            var self = this;
            self.setting();
            self.bindEvent();
        },
        setting : function(){
            var self = this;
            self.$optionPopup = $('#pop_subs_common');

            self.hasSoldOutFixItem = false;

            self.$containBox = self.$optionPopup.find('article.st-quantity');
            self.$el = self.$containBox.parent();
            self.infoText = self.$containBox.find('.amount-info-txt:eq(1)');
            self.selectedInfoText = self.$containBox.find('.amount-info-wrap dd');
            self.itemListBox = self.$containBox.find('.box.payment-amount-list');

        },
        bindEvent : function(){
            var self = this;

            self.itemListBox.on( 'input', '.select-quantity input.quantity', function(e){
                e.preventDefault();
                var $this = $(this);
                var value = $this.val();
                var min = $this.attr('min');
                var isSoldOut = $this.data('soldout');  // 품절여부

                if (isSoldOut){
                    tempData.serviceItemList[$this.data('listIndex')].qty = 0;
                    return;
                }

                // 마이너스 버튼 활성화 여부
                if (!!min && Number(min) == Number(value)){
                    $this.siblings('.minus').attr('disabled', true);
                } else if(!!min && Number(min) < Number(value)){
                    $this.siblings('.minus').attr('disabled', false);
                }
                // 플러스 버튼 활성화 여부
                if (self.getItemCount() == tempData.itemData.maxQty){
                    self.itemListBox.find('button.plus').prop('disabled', true);
                } else {
                    self.itemListBox.find('button.plus').prop('disabled', false);
                }

                self.itemCountUpdate();

                tempData.serviceItemList[$this.data('listIndex')].qty = $this.val();

                //다음 버튼 활성화 여부
                self.announceValidate();
                
            });

            self.itemListBox.on('click', '.select-quantity button.plus', function(e){
                e.preventDefault();
                var $this = $(this);
                var $targetInput = $this.siblings('input.quantity');

                $targetInput.val( Number( $targetInput.val() ) + 1 );
                $targetInput.trigger('input');

            });

            self.itemListBox.on('click', '.select-quantity button.minus', function(e){
                e.preventDefault();
                var $this = $(this);
                var $targetInput = $this.siblings('input.quantity');

                $targetInput.val( Number( $targetInput.val() ) - 1 );
                $targetInput.trigger('input');

            });

            self.$containBox.on('announceValidate', function(){
                self.announceValidate();
            });

            self.$containBox.on('reset', function(){
                self.reset();
            });

        },
        announceValidate : function(){
            var self = this;
            var result = !self.hasSoldOutFixItem && self.minQtyValidate();

            self.$optionPopup.trigger('ITEM_SELECT_COMPLETE', result);
        },
        reset : function(){
            var self = this;

            self.itemListBox.empty();

            tempData.serviceItemList.forEach(function( item ){
                self.itemListBox.append(vcui.template(self.itemTemplate, item));
            });

            self.itemCountUpdate();

            // INPUT 이벤트 강제 발생
            self.itemListBox.find('input.quantity').each(function(){
                $(this).trigger('input');
            });
        },
        addItem : function( result ){
            var self = this;

            tempData.itemData = result.data;
            tempData.serviceItemList = [];

            if (result.data.maxQty == result.data.minQty){
                self.infoText.text('구성 상품의 수량을 총 '+ result.data.maxQty +'개 선택해 주세요');
            } else {
                self.infoText.text('구성 상품의 수량을 최소 '+ result.data.minQty +'개 선택해 주세요');
            }

            self.hasSoldOutFixItem = false;

            self.itemListBox.empty();

            result.data.serviceItemList.forEach(function(item, idx){
                // 품절된 필수 구성 상품이 있는지 확인
                if (item.soldOutYn == 'Y' && item.scItemOptionFlag == 'F'){
                    self.hasSoldOutFixItem = true;
                }

                if (item.scItemOptionFlag == "N"){
                    item.qty = '1';
                }

                item.listIndex = idx.toString();

                tempData.serviceItemList.push( item );
                self.itemListBox.append(vcui.template(self.itemTemplate, item));
            });

            self.itemCountUpdate();

            // INPUT 이벤트 강제 발생
            self.itemListBox.find('input.quantity').each(function(){
                $(this).trigger('input');
            });
        },
        itemCountUpdate : function(){
            var self = this;
            self.selectedInfoText.text( self.getItemCount() + '개');
        },
        getItemCount : function(){
            var self = this;
            var totalCount = 0;
            self.itemListBox.find('input.quantity').each(function(){
                totalCount += Number( $(this).val() );
            });
            return totalCount;
        },
        minQtyValidate : function(){
            var self = this;
            var result = false;
            if (self.getItemCount() >= tempData.itemData.minQty){
                result = true;
            }
            return result;
        },
        getSummaryData : function (){
            var self = this;
            var resultArray = [];
            if (!!tempData.serviceItemList.length){
                tempData.serviceItemList.forEach(function( item ){
                    if (item.qty == '0') return;

                    resultArray.push( item );
                });
            }
            return resultArray;
        },
        itemTemplate :
        '<li {{#if scItemOptionFlag == "N"}} style="display:none;"{{/if}}>' +
            '<dl class="price-info quantity {{#if soldOutYn == "Y"}}soldout{{/if}}" >' +
                '<dt class="amount-list-txt {{#if scItemOptionFlag == "F"}}req{{/if}}"><span class="normal">{{scItemDisplayNm}}</span>{{#if soldOutYn == "Y"}}<span class="label">품절</span>{{/if}}</dt>' +
                '<dd class="content">' +
                    '<div class="quantity-wrap">' +
                        '<div class="select-quantity">' +
                            '<div class="inner">' +
                                '<button type="button" class="minus" disabled="disabled"><span class="blind">빼기</span></button>' +
                                '<input type="number" class="quantity" title="수량 입력" data-list-index="{{listIndex}}" {{#if soldOutYn == "Y"}}data-soldout=true{{#else}}data-soldout=false{{/if}} {{#if soldOutYn == "Y"}}min="0" value="0" {{#else}}{{#if scItemOptionFlag == "F" || scItemOptionFlag == "N" }} min="1" value="1"{{#else}} min="0" value="0" {{/if}} {{/if}} readonly="">' +
                                '<button type="button" class="plus" {{#if soldOutYn == "Y"}}disabled="disabled"{{/if}} ><span class="blind">더하기</span></button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</dd>' +
            '</dl>' +
        '</li>'
    }

    var subscribeOptionSelectPop = {
        init : function(){
            var self = this;
            self.setting();
            self.bindEvent();
            self.setListener();

        },

        setting : function(){
            var self = this;
            self.$optionPopup = $('#pop_subs_common');
            self.$carouselBox = self.$optionPopup.find('.pop-conts.no-footer .slide-wrap');

            self.$resetBtn = self.$optionPopup.find('.pop-footer button:eq(0)');
            self.$prevBtn = self.$optionPopup.find('.pop-footer button:eq(1)');
            self.$nextBtn = self.$optionPopup.find('.pop-footer button:eq(2)');
            self.$addCartBtn = self.$optionPopup.find('.pop-footer button:eq(3)');
            self.$submit = self.$optionPopup.find('.pop-footer button:eq(4)');

            self.closeBtn = self.$optionPopup.find('.btn-close');
            self.chkClosePop = $("#laypop-optChk"); //닫기버튼 클릭시 체크모달
            self.chkCloseOk = self.chkClosePop.find(".btn-wrap > button.btn:nth-child(2)");
            self.chkCloseCancel = self.chkClosePop.find(".btn-wrap > button.btn:nth-child(1)");

            self.serviceSelectData = null;  // STEP1 서비스 선택 데이터

            self.$prevBtn.attr('disabled', true);
            self.$nextBtn.attr('disabled', true);

            // summary
            self.$summary = self.$optionPopup.find('article.st-summ');
            self.summaryServiceGradeText = self.$summary.find('dl dd:eq(0) .aside').eq(0);
            self.summaryServiceTypeText = self.$summary.find('dl dd:eq(0) .aside').eq(1);
            self.summaryServiceCycleText = self.$summary.find('dl dd:eq(0) .aside').eq(2);
            self.summaryModelName = self.$summary.find('dl dd:eq(1) .aside').eq(0);

            
            self.firstMonthPriceText = self.$summary.siblings('.option-fixed').find('.aside');

            self.modelSearchUrl = self.$optionPopup.data("skuUrl");
            self.serviceItemlistUrl = self.$optionPopup.data('serviceItemlistUrl');
            self.serviceInfoUrl = self.$optionPopup.data('serviceInfoUrl');
            




            // 마이 페이지 summary 숨김처리
            if (IS_MYPAGE){
                self.$optionPopup.find('article.st-summ').parents('.slide-conts').remove();
            } else {
                self.$optionPopup.find('article.st-mysumm').parents('.slide-conts').remove();
            }

        },

        setListener : function(){
            var self = this;

            // STEP1 :: 서비스 선택
            self.$optionPopup.on('SERVICE_SELECT_COMPLETE', function( e, result ){
                //console.log('SERVICE SELECT COMPLETE', result);

                var serviceSelectData = serviceSelectStep.getData();

                if (result){

                    var modelSearchPromise = new Promise(function(resolve, reject){
                        $.ajax({
                            url : self.modelSearchUrl,
                            data: {
                                modelId : serviceSelectData.modelId,
                                svcTypeCd : serviceSelectData.svcTypeCd,
                                managementType : serviceSelectData.managementType,
                                visitPer : serviceSelectData.visitPer
                            },
                            success : function (result) {                               
                                resolve( result );
                            },
                            type : "GET",
                            dataType : "json"
                        });
                    }).then(function( value ){
                        var modelSearchResult = value;

                        // 대표모델 있을시 모델명 모름 체크박스 유무
                        if (modelSearchResult.data.virtualModelYn == 'Y'){
                            modelSelectStep.$modelNameChkWrap.show();
                        } else {
                            modelSelectStep.$modelNameChkWrap.hide();
                        }

                        // 서비스 가능 모델 검색 슬라이드 노출여부 처리
                        if (modelSearchResult.data.servicePossibleModelList.length > 1){                                                    
                            //console.log('service model search show');
                            self.$nextBtn.attr('disabled', false);
                        } else {
                            // suffix 모델이 1개일때 서비스 가능 모델 선택 슬라이드 삭제후 구성 상품 목록 가져오기
                            if (self.$optionPopup.find('article.st-model').length){
                                self.searchModelSlide = self.$optionPopup.find('article.st-model').parent().detach();
                            }
                            
                            //console.log('service model search hide');

                            MODEL_DATA.userFriendlyName = modelSearchResult.data.servicePossibleModelList[0].rtModelDisplayNm;
                            MODEL_DATA.itemOptionType = modelSearchResult.data.servicePossibleModelList[0].itemOptionType;

                            lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceItemlistUrl,
                                {
                                    "modelId": serviceSelectData.modelId,
                                    "svcTypeCd" : serviceSelectData.svcTypeCd,
                                    "managementType" : serviceSelectData.managementType,
                                    "visitPer" : serviceSelectData.visitPer,
                                    "rtModelSeq" : modelSearchResult.data.servicePossibleModelList[0].rtModelSeq
                                },
                                function(result){
                                    
                                    var hasDisplayItem = modelSearchResult.data.servicePossibleModelList[0].itemOptionType === 'N' ? false : true;

                                    if (hasDisplayItem == false){                                        
                                        if (self.$optionPopup.find('article.st-quantity').length){
                                            self.itemSelectSlide = self.$optionPopup.find('article.st-quantity').parent().detach();
                                        }
                                        //console.log('item select hide');
                                    }

                                    itemSelectStep.addItem( result );
    
                                    self.$carouselBox.vcCarousel('reinit');
                                    self.$nextBtn.attr('disabled', false);
                            });
                        }
                        
                    });

                } else {
                    self.$nextBtn.attr('disabled', true);
                }
            });
            // STEP2 :: 서비스 모델 선택
            self.$optionPopup.on('SERVICE_MODEL_COMPLETE', function( e, result ){
                //console.log('SERVICE_MODEL_COMPLETE', result);
                if (result){
                    var serviceSelectData = serviceSelectStep.getData();

                    lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceItemlistUrl,
                        {
                            "modelId": serviceSelectData.modelId,
                            "svcTypeCd" : serviceSelectData.svcTypeCd,
                            "managementType" : serviceSelectData.managementType,
                            "visitPer" : serviceSelectData.visitPer,
                            "rtModelSeq" : modelSelectStep.checkedModelData.rtModelSeq
                        },
                        function(result){
                            // 선택된 모델의 아이템 옵션값이 N 이면 구성상품 숨김처리
                            var hasDisplayItem = modelSelectStep.checkedModelData.itemOptionType !== 'N' ? true : false;
                            /*
                            result.data.serviceItemList.forEach(function(item, idx){
                                if (item.scItemDisplayNm !== "Dummy"){
                                    hasDisplayItem = true;
                                }
                            });
                            */
                            // 선택된 모델의 아이템 옵션값이 N 이면 구성상품 숨김처리
                            if (hasDisplayItem == false && self.$optionPopup.find('article.st-quantity').length){                                        
                                self.itemSelectSlide = self.$optionPopup.find('article.st-quantity').parent().detach();
                                self.$carouselBox.vcCarousel('instance').options.initialSlide = 1;
                                self.$carouselBox.vcCarousel('reinit');
                                //console.log('item select hide');
                            }

                            itemSelectStep.addItem( result );

                            self.$nextBtn.attr('disabled', false);
                    });
                } else {
                    self.$nextBtn.attr('disabled', true);
                }
            });
            // STEP3 :: 구성 상품 선택
            self.$optionPopup.on('ITEM_SELECT_COMPLETE', function( e, result ){
                //console.log('ITEM_SELECT_COMPLETE', result);
                var currentSlide = self.$carouselBox.find('.ui_carousel_current');
                // 구성상품페이지일때만
                if (currentSlide.children('article.st-quantity').length){
                    if (result){
                        self.$nextBtn.attr('disabled', false);
                    } else {
                        self.$nextBtn.attr('disabled', true);
                    }
                }
            });

        },

        setSummary : function(){
            var self = this;
            // 서비스 선택
            var serviceTextObj = serviceSelectStep.getSummaryData();

            if (!!serviceTextObj.serviceGrade){
                self.summaryServiceGradeText.parent().show();
                self.summaryServiceGradeText.text( serviceTextObj.serviceGrade );
            } else {
                self.summaryServiceGradeText.parent().hide();
            }

            self.summaryServiceTypeText.text( serviceTextObj.serviceType );
            self.summaryServiceCycleText.text( serviceTextObj.serviceCycle );

            // 서비스 가능 모델
            var modelName = modelSelectStep.getSummaryData();
            if (!!modelName){
                self.$summary.find('dl dt').eq(1).show();
                self.$summary.find('dl dd').eq(1).show();
                self.summaryModelName.text( modelName );
            } else {
                self.$summary.find('dl dt').eq(1).hide();
                self.$summary.find('dl dd').eq(1).hide();
            }

            // 구성 상품 목록
            var itemArray = itemSelectStep.getSummaryData();
            var itemBox = self.$summary.find('dl dd').eq(2).find('ul');
            var isDummy = MODEL_DATA.itemOptionType === 'N' ? true : false;
            
            if (!!itemArray.length && isDummy == false){
                self.$summary.find('dl dt').eq(2).show();
                self.$summary.find('dl dd').eq(2).show();

                itemBox.empty();

                var titHtml = '<li class="option-list__head"><em class="tit">'+ MODEL_DATA.userFriendlyName +'</em></li>';
                itemBox.append(titHtml);

                itemArray.forEach(function( item ){
                    var itemHtml = '<li class="option-list__item"><p class="tit">'+ item.scItemDisplayNm +'</p><span class="aside">수량:'+ item.qty +'개</span></li>';
                    itemBox.append(itemHtml);
                });
            } else {
                self.$summary.find('dl dt').eq(2).hide();
                self.$summary.find('dl dd').eq(2).hide();
            }

            // 1회차 금액 가져오기
            var scItemSeqCollect = '';
            itemArray.forEach(function( item, idx ){
                var preFix = ',';
                if ( idx == 0){
                    preFix = '';
                }
                scItemSeqCollect += preFix + item.scItemSeq;
            });
            lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(self.serviceInfoUrl,
                {
                    "modelId": MODEL_DATA.modelId,
                    "scModelSeq" : itemArray[0].scModelSeq,
                    "rtModelSeq" : itemArray[0].rtModelSeq,
                    "scItemSeq" : scItemSeqCollect,
                    "visitPer" : serviceSelectStep.getData().visitPer
                },
                function(result){
                    var totalPrice = 0;
                    result.data.subscriptionItemInfoList.forEach(function( itemInfo ){
                        itemArray.forEach(function( item ){
                            if (item.scItemSeq == itemInfo.scItemSeq){
                                totalPrice += Number(item.qty) * itemInfo.monthPriceList[0].promoPrice;
                            }
                        });
                    });
                    self.firstMonthPriceText.text( '월 ' + vcui.number.addComma(totalPrice) + '원');
                }
            );
        },

        bindEvent : function(){
            var self = this;

            self.$optionPopup.on('modalshown', function(){
                // 버튼 클릭해서 열리는 경우에만 작동
                if (self.isPopupOpen){
                    //self.$carouselBox.vcCarousel('update');
                    self.$carouselBox.vcCarousel('instance').options.initialSlide = 0;
                    self.$carouselBox.vcCarousel('reinit');
                    self.isPopupOpen = false;
                }
            });

            self.$carouselBox.vcCarousel({
                activeClass: '',         // 활성 css 클래스
                accessibility: true,            // 접근성 속성(aria-)들을 붙일것인가
                adaptiveHeight: false,          // 높이를 유동적으로 할것인가
                arrows: true,                   // 좌우버튼을 표시할 것인가
                autoplay: false,                // 자동 재생 여부
                centerMode: false,              // 활성화된 슬라이드를 가운데에 위치시킬 것인가...
                cssEase: 'ease-in-out',                // css ease
                speed: 300,
                draggable: false,                // 마우스로 슬라이드가 되도록 허용할 것인가
                easing: 'linear',               // slide easing 타입 easeInOutQuad
                edgeFriction: 0.35,             // infinite:false일 때 끝에 다다랐을 때의 바운싱 효과 크기
                fade: false,                    // 슬라이딩이 아닌 fade in/out으로 할 것인가
                infinite: false,                 // 무한루프 사용 여부
                swipe: false,                    // 스와이핑 허용 여부
                swipeToSlide: false,            // 사용자가 slidesToScroll과 관계없이 슬라이드로 직접 드래그 또는 스 와이프 할 수 있도록 허용
                touchMove: false,                // 터치로 슬라이드 모션 사용
                useCSS: true,                   // CSS 전환 활성화 / 비활성화
                useTransform: true,             // CSS 변환 활성화 / 비활성화
                variableWidth: false,           // 가변 너비 슬라이드
                vertical: false,                // 세로 슬라이드 모드
                verticalSwiping: false,         // 수직 스 와이프 모드
                preventVertical: false,         // 슬라이딩 할 때 수직으로 움직이는 걸 막을 것인가.
                waitForAnimate: true,           // 애니메이션을 적용하는 동안 슬라이드를 앞으로 이동하라는 요청을 무시합니다.
                zIndex: 1000,                    // 슬라이드의 zIndex 값 설정, IE9 이하의 경우 유용함
                activeHover: false,
                additionWidth: 0,                // 모듈이 내부 너비를 제대로 계산 못할 때 가감할 너비를 설정
                lastFix : false
            });

            // 리셋 버튼
            self.$resetBtn.on('click', function(){
                var currentSlide = self.$carouselBox.find('.ui_carousel_current');
                var isSummary = currentSlide.children('article').hasClass('st-summ');
                var isModelSearch = currentSlide.children('article').hasClass('st-model');                
                
                if (isSummary || isModelSearch){
                    self.reset();
                    self.$carouselBox.vcCarousel('instance').options.initialSlide = 0;
                    self.$carouselBox.vcCarousel('reinit');

                } else {
                    currentSlide.children('article').trigger('reset');
                }
            });
            // 이전 버튼
            self.$prevBtn.on('click', function(){
                self.$carouselBox.vcCarousel('prev');
            });
            // 다음 버튼
            self.$nextBtn.on('click', function(){
                self.$carouselBox.vcCarousel('next');
            });

            self.$carouselBox.on('carouselafterchange', function( event, carousel, index ){
                var currentSlide = self.$carouselBox.find('.ui_carousel_current');

                currentSlide.children('article').trigger('announceValidate');   // 슬라이드 완료시 현재 step 필수값 검증

                index == 0 ? self.$prevBtn.attr('disabled', true).hide() : self.$prevBtn.attr('disabled', false).show();  // 슬라이드 완료시 이전 버튼 설정

                // 구성 상품 선택 페이지일때
                if (currentSlide.children('article.st-quantity').length){
                    // 필수 상품이 품절일떄만
                    if (itemSelectStep.hasSoldOutFixItem){
                        lgkorUI.alert('신청이 불가한 상품입니다.<br>다른 상품을 신청해주세요.');
                    }
                }

                // Summary 페이지일때
                if (currentSlide.children('article.st-summ').length || currentSlide.children('article.st-mysumm').length){
                    self.setSummary();
                    
                    self.$prevBtn.hide();
                    self.$nextBtn.hide();
                    self.$addCartBtn.show();
                    self.$submit.show();
                } else {
                    self.$addCartBtn.hide();
                    self.$submit.hide();
                    self.$prevBtn.show();
                    self.$nextBtn.show();
                }

            });

            self.$optionPopup.on('popup', function(e, url){

                
                serviceSelectStep.setServiceType();     // 서비스 타입 ajax 불러오기

                self.slideReset();  // 슬라이드 복구
                
                self.loginCheckUrl = url;
                self.isPopupOpen = true;

                $.ajax({
                    url : self.loginCheckUrl,                    
                    type : 'POST',
                    data : { 'href' : location.pathname },
                    success : function( result ){
                        var data = result.data;
                        if (!!data.alert){
                            lgkorUI.confirm(data.alert.title, {                                
                                cancelBtnName : data.alert.cancelBtnName,
                                okBtnName : data.alert.okBtnName,
                                ok : function(){
                                    location.href = data.alert.okUrl;
                                }
                            });
                        } else {
                            self.$prevBtn.hide();
                            self.$optionPopup.vcModal('show');
                        }
                    }
                });

            });

            self.closeBtn.on('click', function(e){
                e.preventDefault();

                // 필수구성상품이 품절일때 즉시 팝업 닫기
                if (itemSelectStep.hasSoldOutFixItem === true){
                    self.reset();
                    self.$optionPopup.vcModal('hide');
                    return;
                }

                var currentSlide = self.$carouselBox.find('.ui_carousel_current');
                var msg = '상품 옵션 미선택 시<br>다음 단계 진행이 불가합니다.<br>종료할까요?';
                var cancelBtnTxt = '아니요';
                var okBtnTxt = '네';

                if (currentSlide.children('article.st-model').length){
                    msg = '입력을 완료해야 구독 신청이 가능합니다.';
                    cancelBtnTxt = '취소';
                    okBtnTxt = '닫기';
                }

                if (currentSlide.children('article.st-quantity').length){
                    msg = '상품 옵션을 선택해야 다음 단계 진행이 가능합니다.';
                    cancelBtnTxt = '취소';
                    okBtnTxt = '닫기';
                }

                lgkorUI.confirm( msg, {                                
                    cancelBtnName : cancelBtnTxt,
                    okBtnName : okBtnTxt,
                    ok : function(){
                        self.reset();
                        self.$optionPopup.vcModal('hide');
                    }
                });
            });

            self.$addCartBtn.on('click', function(e){
                e.preventDefault();

                var itemData = itemSelectStep.getSummaryData();
                var sendItemData = [];
                
                itemData.forEach(function(item){
                    sendItemData.push({
                        'scItemSeq' : item.scItemSeq,
                        'qty' : item.qty
                    });
                });
                
                var modelData = {
                    'modelName' : modelSelectStep.getSummaryData(),
                    'rtModelSeq' : itemData[0].rtModelSeq,
                    'scModelSeq' : itemData[0].scModelSeq,
                    'itemList' : sendItemData
                };

                self.addSubscribeCartStorage(modelData);

            });

            // 바로 신청하기
            self.$submit.on('click', function(e){
                e.preventDefault();

                var itemData = itemSelectStep.getSummaryData();
                var sendItemData = [];
                
                itemData.forEach(function(item){
                    sendItemData.push({
                        'scItemSeq' : item.scItemSeq,
                        'qty' : item.qty
                    });
                });
                
                var submitData = {
                    'modelList' : [{
                        'modelName' : modelSelectStep.getSummaryData(),
                        'rtModelSeq' : itemData[0].rtModelSeq,
                        'scModelSeq' : itemData[0].scModelSeq,
                        'itemList' : sendItemData
                    }]
                };

                var $form = $('<form method="post" action="/order-to-pay/care-ship"><input type="text" name="submitData"/></form>');
                $form.find('[name=submitData]').val( JSON.stringify(submitData) );
                $('html').append( $form );
                $form.submit();
            });
        },

        // 구독 담기 
        addSubscribeCartStorage : function( modelData ){
            var self = this;
            var storage = window.sessionStorage;
            var hasKey = !!storage.getItem(STORAGE_KEY);   // 구독 담기 영역이 있는지 여부            

            if (!hasKey){
                var defaultData = { 'modelList' : [] };
                storage.setItem( STORAGE_KEY, JSON.stringify(defaultData) );
            }

            var cartData = JSON.parse(storage.getItem( STORAGE_KEY ));

            if (cartData.modelList.length == 10){
                lgkorUI.alert('', { title : '상품은 한 번에<br>10개까지 신청할 수 있습니다.'});
                self.$optionPopup.vcModal('hide');
                self.reset();

                return;
            }

            cartData.modelList.push( modelData );

            storage.setItem( STORAGE_KEY, JSON.stringify(cartData) );

            self.$optionPopup.vcModal('hide');
            self.reset();
            
            var toastHtml = '<a href="/care-solutions/subscription"><p>상품이 담겼습니다.</p><span class="link-underline">담은 상품 보러가기</span></a>';            
            $(window).trigger("toastshowHtml", toastHtml, 3000);
            
        },

        loadData : function(){
            var self = this;
            // 서비스 타입 목록 설정
            self.serviceTypeSelect.empty();
            SAVE_OPTION_DATA.serviceTypeList.forEach(function(item, idx){
                var option;
                if (idx == 0){
                    option = '<option value="" class="placeholder">선택하세요</option>';
                } else {
                    option = '<option value="'+ item.svcTypeCd +'">'+ item.svcTypeDesc +'</option>';
                }
                self.serviceTypeSelect.append(option);

            });
            // 서비스 타입이 없을때
            if (SAVE_OPTION_DATA.serviceTypeList.length == 1){
                self.hasServiceType = false;
                self.serviceTypeSelect.prop('disabled', true);
                //self.serviceTypeSelect.trigger('change');
            } else {
                self.serviceTypeSelect.prop('disabled', false);
            }
            self.serviceTypeSelect.prop('selectedIndex', SAVE_OPTION_DATA.serviceTypeListIndex).vcSelectbox('update');

            // 서비스 유형 설정
            self.serviceManageSelect.empty();
            self.serviceManageSelect.append('<option value="" class="placeholder">선택하세요</option>');

            SAVE_OPTION_DATA.serviceManagementList.forEach(function(item, idx){
                var option;
                option = '<option value="'+ item.managementType +'">'+ item.managementName +'</option>';
                self.serviceManageSelect.append(option);
            });
            self.serviceManageSelect.prop('disabled', false);
            self.serviceManageSelect.prop('selectedIndex', SAVE_OPTION_DATA.serviceManagementListIndex).vcSelectbox('update');

            // 서비스 주기 설정
            self.serviceCycleSelect.empty();
            self.serviceCycleSelect.append('<option value="" class="placeholder">선택하세요</option>');
            SAVE_OPTION_DATA.serviceCycleList.forEach(function(item, idx){
                var option;
                option = '<option value="'+ item.visitPer +'">'+ '1회/'+ item.visitPer +'개월'  +'</option>';
                self.serviceCycleSelect.append(option);
            });
            self.serviceCycleSelect.prop('disabled', false);
            self.serviceCycleSelect.prop('selectedIndex', SAVE_OPTION_DATA.serviceCycleListIndex).vcSelectbox('update');

            // 구성상품 설정
            var hasDisplayItem = false;

            self.infoText.text('구성 상품의 수량을 총 '+ SAVE_OPTION_DATA.itemData.maxQty +'개 선택해 주세요');

            self.itemListBox.empty();

            SAVE_OPTION_DATA.serviceItemList.forEach(function(item, idx){
                if (item.scItemDisplayNm !== "Dummy"){
                    hasDisplayItem = true;
                }
                item.listIndex = idx.toString();
                self.itemListBox.append(vcui.template(self.itemTemplate, item));
            });

            if (hasDisplayItem){
                self.itemCountUpdate();
                self.itemListWrap.show();
            }

            // INPUT 이벤트 강제 발생
            self.itemListWrap.find('input.quantity').each(function(){
                $(this).trigger('input');
            });
        },

        slideReset : function(){
            var self = this;
            // 삭제된 페이지 복구
            if (!self.$optionPopup.find('article.st-model').length){
                serviceSelectStep.$el.after( self.searchModelSlide );
                //modelSelectStep.init();
            }

            if (!self.$optionPopup.find('article.st-quantity').length){
                modelSelectStep.$el.after( self.itemSelectSlide );
                //itemSelectStep.init();
            }

            self.$carouselBox.vcCarousel('instance').options.initialSlide = 0;
            self.$carouselBox.vcCarousel('reinit');
            
        },

        reset : function(){
            var self = this;

            self.slideReset();

            serviceSelectStep.reset();
            modelSelectStep.reset();
            itemSelectStep.reset();

            self.$addCartBtn.hide();
            self.$submit.hide();
            self.$nextBtn.show();
        }
    }

    function funcReady() {
        // 구독페이지일때만 실행
        if (lgePdpSendData.bizType !== 'SUBSCRIPTION'){
            return;
        }
        // 옵션선택팝업
        subscribeOptionSelectPop.init();

        // 서비스 셀렉트 :: STEP1
        serviceSelectStep.init();
        // 서비스 가능 모델 선택 :: STEP2
        modelSelectStep.init();
        // 구성상품 선택 :: STEP3
        itemSelectStep.init();
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'PROD', name: 'KRP0008-subscribe', isFirstLoad: true, fn: function () {
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function() {
        SAVE_COMPONENT_PDP_DOM_MNG();

        funcReady();
    });
})(window);


